// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xCcB","icon":"styles_icon__jZgkQ"};